import src from "IMAGE";
export default { src, width: 482, height: 482, blurWidth: 0, blurHeight: 0};
